import { CredentialProvider } from './types'

export type CustomTokenInput = {
  token: string
}

/**
 * A token the backend minted, for a uid it chose.
 *
 * It has no sign-in UI, which is why it was not one of the four "social" sources — but it is
 * a credential source like any other, and the two callers that use it (impersonation, and
 * signing in after e-mail verification) are entry points into the same flow. Keeping it
 * outside the interface would leave a second door into the machine, which is the thing this
 * feature exists to close. See EPIC-005.
 */
export const customTokenProvider: CredentialProvider<CustomTokenInput> = {
  id: 'customToken',

  async authenticate({ token }) {
    return { kind: 'customToken', provider: 'customToken', token }
  }
}
